import type { Content } from "@prismicio/client"
import type { SliceComponentProps } from "@prismicio/react"

import { RichText } from "@/components/Generic/RichText/RichText/RichText"
/**
 * Props for `Text`.
 */
type Context = { interpolations: Record<string, string> }
export type TextProps = SliceComponentProps<Content.TextSlice, Context>

/**
 * Component for "Text" Slices.
 */
const Text = ({ slice, context }: TextProps): React.JSX.Element => {
  return <RichText field={slice.primary.text} interpolations={context.interpolations} />
}

export default Text
